const NOTAMActiveState = {
	PAST: "Past NOTAMs",
	CURRENT: "Current NOTAMs",
	FUTURE: "Future NOTAMs"
};
export default NOTAMActiveState;
